/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Presence_S4Inputs */

const en_tut_presence_s4 = /** @type {(inputs: Tut_Presence_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in the **Catatan serah terima** before leave. **Susun otomatis dari issue saya** drafts it from your open issues and pending approvals.`)
};

const id_tut_presence_s4 = /** @type {(inputs: Tut_Presence_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi **Catatan serah terima** sebelum cuti. **Susun otomatis dari issue saya** menyiapkan drafnya dari issue terbuka dan approval tertunda Anda.`)
};

/**
* | output |
* | --- |
* | "Fill in the **Catatan serah terima** before leave. **Susun otomatis dari issue saya** drafts it from your open issues and pending approvals." |
*
* @param {Tut_Presence_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_presence_s4 = /** @type {((inputs?: Tut_Presence_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Presence_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_presence_s4(inputs)
	return en_tut_presence_s4(inputs)
});